module.exports = __webpack_public_path__ + "img/54exp.a5656ff0.jpg";